<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex">
        <!-- <el-col :span="2"> -->
        <!-- <el-button
          style="margin-left:10px;"
          plain  
          class="add-column-btn bbox"
          @click="gotoDetail('')"
          type="primary"
        >
          <i class="el-icon-plus fw900 f16"></i> 新增</el-button
        > -->
        <!-- </el-col> -->
        <!-- <el-col :span="7"> -->
        <div class="block">
          <el-form :inline="true">
            <el-form-item label="日期:">
              <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收银员:">
              <el-select clearable value-key="id" v-model="checkOutUser">
                <el-option
                  v-for="(item, i) in checkOutList"
                  :label="`${item.nickName}(${item.loginName})`"
                  :value="item"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="search-btn">
            <el-button type="primary" @click="search()">搜索</el-button>
          </div>
        </div>
        <!-- </el-col> -->
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >总营业额 ：{{ sumDetail.totalSaleFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >微信 ：{{ sumDetail.weChatPayFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="warning" class="sumBtn"
              >支付宝 ：{{ sumDetail.aliPayFee }}</el-button
            >
          </div>
        </el-col>
        <!-- <el-col>
                     <div >
                        <el-button type="primary" >现金 ：{{cash}}</el-button>
                    </div>
                 </el-col> -->
        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >会员卡 ：{{ sumDetail.memberCardPayFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >会员充值 ：{{ sumDetail.memberStoredFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="warning" class="sumBtn"
              >销售数量 ：{{ sumDetail.saleCount }}</el-button
            >
          </div>
        </el-col>

        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >美团团购 ：{{ sumDetail.meituan }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >抖音团购 ：{{ sumDetail.douyin }}</el-button
            >
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%"> -->
      <el-table
        :data="tableData"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="56vh"
      >
        <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
        <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column> -->
        <el-table-column label="销售额" align="center" prop="销售额">
          <template slot-scope="scope">
            <span>{{ scope.row.totalSaleFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信收款" align="center" prop="微信收款">
          <template slot-scope="scope">
            <span>{{ scope.row.weChatPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付宝收款" align="center" prop="支付宝收款">
          <template slot-scope="scope">
            <span>{{ scope.row.aliPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员卡收款" align="center" prop="会员卡收款">
          <template slot-scope="scope">
            <span>{{ scope.row.memberCardPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="现金" align="center" prop="现金">
          <template slot-scope="scope">
            <span>{{ scope.row.cashFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="美团团购" align="center" prop="美团团购">
          <template slot-scope="scope">
            <span>{{ scope.row.meituan | 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="抖音团购" align="center" prop="抖音团购">
          <template slot-scope="scope">
            <span>{{ scope.row.douyin | 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="操作员编码" align="center" prop="操作员编码">
          <template slot-scope="scope">
            <span
              >{{ scope.row.waiterCode }}
              <template v-if="scope.row.waiterName != ''">
                ({{ scope.row.waiterName }})</template
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column label="日结日期" align="center" prop="日结日期">
          <template slot-scope="scope">
            <span>{{ scope.row.dayTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="银行卡收款" align="center" prop="银行卡收款">
          <template slot-scope="scope">
            <span>{{ scope.row.bankCardPayFee }}</span>
          </template>
        </el-table-column>
       -->
        <!--
                    <el-table-column label="操作员" align="center"  prop="操作员" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.waiterName }}</span>
                        </template>
                    </el-table-column> -->
        <!-- <el-table-column
          label="会员充值金额"
          align="center"
          prop="会员充值金额"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.memberStoredFee }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="总入账" align="center" prop="总入账">
          <template slot-scope="scope">
            <span>{{ scope.row.totalEnterFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售额" align="center" prop="销售数量">
          <template slot-scope="scope">
            <span>{{ scope.row.saleAccount }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="日结日期" align="center" prop="日结日期">
          <template slot-scope="scope">
            <span>{{ scope.row.dailyDt | dataFormat }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="交班时间" align="center"  prop="交班时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.changeDt }}</span>
                        </template>
                    </el-table-column> -->
        <el-table-column label="交易数量" align="center" prop="交易笔数">
          <template slot-scope="scope">
            <span>{{ scope.row.saleCount }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="交班现金" align="center" prop="交班现金">
          <template slot-scope="scope">
            <span>{{ scope.row.changeCashier }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="连锁编码" align="center"  prop="连锁编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupCode }}</span>
                        </template>
                    </el-table-column> -->
        <!-- <el-table-column label="连锁名称" align="center"  prop="连锁名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="现金收款" align="center"  prop="现金收款" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.cashFee }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员赠送" align="center"  prop="会员赠送" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.memberPresentSum }}</span>
                        </template>
                    </el-table-column> -->
        <!-- <el-table-column
                        label="操作"
                        align="center"
                        class-name="small-padding fixed-width"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                                class="item"
                                effect="dark"
                                content="编辑"
                                placement="bottom"
                        >
                            <i
                                    class="el-icon-edit textblue f16"
                                    @click="gotoDetail(scope.row.id, scope.row.userCode)"
                            ></i>
                        </el-tooltip>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="bottom"
                        >
                            <i
                                    class="el-icon-delete textblue f16 ml20"
                                    @click="del(scope.row.id)"
                            ></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
      </el-table>
      <!-- </el-row></el-scrollbar
        >
		</div> -->
      <!-- <div class="footerBox"> -->
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.currPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalAmount"
      ></el-pagination>
      <!-- </div> -->
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      checkOutList: [],
      checkOutUser: "",
      totalAmount: 0,
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: [],
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      total: 0,
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          merchantCode: localStorage.getItem("merchantCode"),
        },
      },
      queryBean: {
        merchantCode: "",
      },
      userlist: [],
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      //统计
      sumDetail: {},
      meituan: 0,
      douyin: 0,
    };
  },
  created() {
    // this.queryInfo.currPage = this.$route.query.currPage;
    // this.queryInfo.pageSize = this.$route.query.pageSize;
    this.queryInfo.condition.startDt = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.queryInfo.condition.endDt = moment().subtract(1, "days").format("YYYY-MM-DD");
    this.getListData();
    this.dateRange[0] = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.dateRange[1] = moment().subtract(1, "days").format("YYYY-MM-DD");
    console.log(this.queryInfo);
    this.getCheckOutUser();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      console.log(this.dateRange, this.checkOutUser);
      if (this.checkOutUser != "" && this.checkOutUser != null) {
        this.queryInfo.condition.checkOutUserName = this.checkOutUser.nickName;
        this.queryInfo.condition.checkOutUserCode = this.checkOutUser.loginName;
      } else {
        this.queryInfo.condition.checkOutUserName = null;
        this.queryInfo.condition.checkOutUserCode = null;
      }
      if (this.dateRange != null && this.dateRange.length > 0) {
        this.queryInfo.condition.startDt = this.dateRange[0];
        this.queryInfo.condition.endDt = this.dateRange[1];
      } else {
        this.queryInfo.condition.startDt = null;
        this.queryInfo.condition.endDt = null;
      }

      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantDailyRecords/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },
    // 收银员下拉框
    getCheckOutUser() {
      this.$http
        .post("merchantEmployeeRoyaltyArea/queryTableRoyaltyEmployeeList", {
          merchantCode: localStorage.getItem("merchantCode"),
        })
        .then((res) => {
          // console.log(res)
          this.checkOutList = res.data.data;
        });
    },
    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantDailyRecord/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      this.$http
        .post("merchantDailyRecords/shiftRecord", this.queryInfo)
        .then((response) => {
          console.log(response.data.data);
          if (response.data.code == 200) {
            // console.log('页码',this.total)
            this.totalAmount = response.data.data.count;
            // that.queryInfo.currPage = response.data.data.currPage;
            this.tableData = response.data.data.data;
            let total = 0;
            let wxCharge = 0;
            let aliCharge = 0;
            let card = 0;
            let charge = 0;
            let sellNum = 0;
            let meituan = 0;
            let douyin = 0;
            this.tableData.forEach((e) => {
              if (e.totalSaleFee) {
                total += parseFloat(e.totalSaleFee);
              }
              if (e.weChatPayFee) {
                wxCharge += parseFloat(e.weChatPayFee);
              }
              if (e.aliPayFee) {
                aliCharge += parseFloat(e.aliPayFee);
              }
              if (e.memberCardPayFee) {
                card += parseFloat(e.memberCardPayFee);
              }
              if (e.memberStoredFee) {
                charge += parseFloat(e.memberStoredFee);
              }
              if (e.saleCount) {
                sellNum += parseFloat(e.saleCount);
              }
              meituan += parseFloat(e.meituan);
              douyin += parseFloat(e.douyin);
            });
            this.sumDetail = {
              totalSaleFee: total.toFixed(2),
              weChatPayFee: wxCharge.toFixed(2),
              aliPayFee: aliCharge.toFixed(2),
              memberCardPayFee: card.toFixed(2),
              memberStoredFee: charge.toFixed(2),
              saleCount: sellNum.toFixed(2),
              meituan: meituan.toFixed(2),
              douyin: douyin.toFixed(2),
            };
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
  },
};
</script>

<style lang="less" scoped>
.block {
  display: flex;
  margin-left: 10px;
}
.search-btn {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      // height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
      margin-bottom: 10px;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
.managingPeople .el-card {
  height: 90vh !important;
}
.sumBtn {
  height: 80px;
  min-width: 150px;
}
</style>
